import { render, staticRenderFns } from "./JCodeEditor2.vue?vue&type=template&id=cb8494c2"
import script from "./JCodeEditor2.vue?vue&type=script&lang=js"
export * from "./JCodeEditor2.vue?vue&type=script&lang=js"
import style0 from "./JCodeEditor2.vue?vue&type=style&index=0&id=cb8494c2&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8494c2')) {
      api.createRecord('cb8494c2', component.options)
    } else {
      api.reload('cb8494c2', component.options)
    }
    module.hot.accept("./JCodeEditor2.vue?vue&type=template&id=cb8494c2", function () {
      api.rerender('cb8494c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JCodeEditor2.vue"
export default component.exports